<template>
  <d-container fluid class="main-content-container px-4">
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">
          {{ $t('letrex.create.subtitle') }}
        </span>
        <h3 class="page-title">{{ $t('letrex.create.title') }}</h3>
      </d-col>
    </d-row>

    <letrex-page />
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import { cloneDeep } from '_utils';
import Events from '_utils/events';
import { MODEL } from '../components/LetrexModel';
import LetrexPage from '../components/LetrexPage.vue';

export default {
  name: 'letrex-create',
  components: {
    LetrexPage,
  },
  methods: {
    ...mapActions(['setLetrex']),
  },
  created() {
    Events.$emit('sidebarVisible', false);
    this.setLetrex(cloneDeep(MODEL));
  },
};
</script>
